import { h, Component } from 'preact';

import scrollToElement from 'scroll-to-element';
import FontAwesomeIcon from './fontAwesomeIcon.js';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

import ContentHandler from '../util/contentHandler.js';
import style from '../../style/mobileCallToAction.sass';

const getMobileCallToActionStyleClassNames = (brand) => {
  if(brand === 'reem'){
    return {
      containerStyle: style.container,
      borderStyle: style.bubbleBorder,
      innerStyle: style.bubbleInner,
      offerStyles: [style.offer]
    };
  }
  if(brand === 'ruud'){
    return {
      containerStyle: style.containerRuud,
      borderStyle: style.ruudBorder,
      innerStyle: style.ruudInner,
      offerStyles: [style.offer, style.offerRuud]
    };
  }
  if(brand === 'friedrich'){
    return {
      containerStyle: style.containerFriedrich,
      borderStyle: style.friedrichBorder,
      innerStyle: style.friedrichInner,
      offerStyles: [style.offer, style.offerFriedrich]
    };
  }
  return {
    containerStyle: style.container,
    borderStyle: style.bubbleBorder,
    innerStyle: style.bubbleInner,
    offerStyles: [style.offer]
  };
};

export default class MobileCallToAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showButtons: false
    };
    this.handleFormModalClick = this.handleFormModalClick.bind(this);
    this.checkScroll = this.checkScroll.bind(this);
    //this.scrollToDivider = this.scrollToDivider.bind(this);
  }
  handleFormModalClick(event){
    event.preventDefault();
    this.props.showForm();
  }
  componentDidMount() {
    window.document.addEventListener('scroll', this.checkScroll);
  }
  componentWillUnmount(){
    window.document.removeEventListener('scroll', this.checkScroll);
  }
  checkScroll(){
    if(this.props.contractor && this.props.dividerRef){
      const selfRect = this.base.getBoundingClientRect();
      const selfBottom = selfRect?selfRect.top + selfRect.height:null;
      const dividerRect = this.props.dividerRef.base.getBoundingClientRect();
      const dividerTop = dividerRect?dividerRect.top:null;
      const showButtons = dividerTop  < selfBottom ;
      if (showButtons !== this.state.showButtons) {
        this.setState({ showButtons });
      }
    }
  }
  /*
  scrollToDivider(){
    scrollToElement(this.props.dividerRef.base,{
      align: 'bottom'
    });
  }
  */
  render(props) {
    /*
    if(!props.contractor){
      return null;
    }
    const darkenStyle = (props.brand === 'ruud')?style.darkenRuud:style.darken;
    const contentHandler = new ContentHandler();
    const trackingNumber = contentHandler.getTrackingPhoneNumber(props);

    const innerCompenents = this.state.showButtons?[
      (<span className={style.textRight}>
        <a className={style.contractorPhoneNumber} href={'tel:'+trackingNumber} onClick={props.sendClickToCallData}>
          <FontAwesomeIcon icon={faPhone} />
          &nbsp;CALL
        </a>
      </span>),
      (<span onClick={this.handleFormModalClick} className={[darkenStyle, style.textLeft].join(' ')}>
        <FontAwesomeIcon icon={faEdit} />
        &nbsp;SCHEDULE
      </span>),
    ]:[(
      <div onClick={this.scrollToDivider}>
        <p className={style.top}>FREE ESTIMATE!</p>
        <p>SCHEDULE WITH  A PRO PARTNER NOW</p>
      </div>
    )];
    */

    const contractor = Array.isArray(props.contractors)?props.contractors[0]:null;
    if(!contractor){
      return null;
    }
    const innerCompenents = (
      <div onClick={props.onContractorListLinkClick}>
        <p className={style.top}>FREE ESTIMATE!</p>
        <p>SCHEDULE WITH  A PRO PARTNER NOW</p>
      </div>
    );
    const classNames = getMobileCallToActionStyleClassNames(props.brand);
    return (
      <div id="mobile-call-to-action" className={classNames.containerStyle}>
        <div className={classNames.borderStyle}></div>
        <div className={classNames.innerStyle}>
          <div className={classNames.offerStyles.join(' ')}>
            {innerCompenents}
          </div>
        </div>
      </div>
    );
  }
}
